import type { FaireProductEntity } from "../../entity_types/product";

export const p_r44rjub8dr: FaireProductEntity = {
  token: "p_r44rjub8dr",
  type: "product",
  name: "Green Yuzu Kosho (100g)",
  brandToken: "b_8wdpzbkr8w",
  brandName: "YUZUCO",
  imageUrl:
    "https://cdn.faire.com/fastly/c012cf69a796d26153827085398b3ba1e95507d25e539bd455029f0eab1e8f68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c8acf20c3e476438a35fb5eb1d0dcf58ad809450e72193350bdadfe728b639c.jpeg",
    "https://cdn.faire.com/fastly/916e99bd1b197a720ea4c30a2f7821ac1be37482a2310e16ffd33cbe607c8c4d.png",
    "https://cdn.faire.com/fastly/79718ed401899526ce0b3df59f646fa15724c24918d330818077445ebbd930bd.png",
    "https://cdn.faire.com/fastly/6900406d47e13cb9af7a84547a2c1c6e611514279af9fc992a8241ab08beaee0.jpeg",
    "https://cdn.faire.com/fastly/d831474bb6f3bc2a91c100f185dd3a2293136a6fe1027c42fe1af8fa2a3f3ac2.jpeg",
    "https://cdn.faire.com/fastly/3b489df49f24905b8840964004f229960267af0c7ccc0896161f30f5296598b4.jpeg",
  ],
  priceDollars: 8,
  description:
    "Citrus, salt, and spice - a perfect trio. Three simple ingredients that prove less is more. This bold paste is a delicious condiment on its own when dotted onto bites of fish, meat, chicken or veggies. It also performs beautifully as an addition to sauces, aiolis, soups, dressings, marinades, and everything in between. A beloved staple across Japan, Yuzu Kosho is made by combining yuzu peel, salt, and a spicy pepper into a paste. Produced in Miyazaki Prefecture, Japan. Your new pantry essential. \n\nLoved by professional chefs, bartenders, baristas, bakers and butchers alike. A healthy and natural choice for all your summer barbecue needs. Creates the absolute perfect bite of steak, especially when it's a rich fatty cut of beef. Try combining with olive oil, make an aioli, dab on pizza, fires or chips.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:27.774Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
